import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { UtensilsCrossed, CheckCircle2 } from "lucide-react";
import api from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { isoToday, shiftDate, errorKey } from "@/lib/foodlog";

const DAYS = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

// Date réelle du jour du programme dans la semaine en cours (lundi → dimanche) ; null si à venir.
export function planDayDate(day) {
  const today = isoToday();
  const todayIdx = (new Date(today + "T12:00:00Z").getUTCDay() + 6) % 7;
  const diff = DAYS.indexOf(day) - todayIdx;
  return diff > 0 ? null : shiftDate(today, diff);
}

// Repas du programme → journal via le suivi (entrée idempotente plan_slot : jamais de doublon).
export function PlanEatButton({ day, slot, memberId }) {
  const { t } = useLang();
  const qc = useQueryClient();
  const [busy, setBusy] = useState(false);
  const date = planDayDate(day);
  const { data } = useQuery({ queryKey: ["tracking", date], queryFn: async () => (await api.get(`/tracking/${date}`)).data, enabled: !!date });
  if (!date) return null;
  const eaten = (data?.by_member?.[memberId]?.consumed || []).includes(slot);
  const toggle = async () => {
    setBusy(true);
    try {
      await api.post("/tracking/toggle", { date, slot, member_id: memberId });
      toast.success(t(eaten ? "j_deleted" : "j_added"));
      qc.invalidateQueries({ queryKey: ["tracking"] }); qc.invalidateQueries({ queryKey: ["food-day"] }); qc.invalidateQueries({ queryKey: ["food-history"] });
    } catch (e) { toast.error(e.response?.data?.detail && typeof e.response.data.detail === "string" && e.response.status === 400 ? e.response.data.detail : t(errorKey(e))); } finally { setBusy(false); }
  };
  return (
    <button onClick={toggle} disabled={busy} data-testid={`plan-eat-${slot}`} aria-pressed={eaten}
      className={`mt-3 w-full inline-flex items-center justify-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-medium transition-colors disabled:opacity-60 ${eaten ? "border-chenia-sage bg-chenia-sage/30 text-foreground" : "border-border hover:bg-secondary"}`}>
      {eaten ? <CheckCircle2 className="h-4 w-4 text-primary" /> : <UtensilsCrossed className="h-4 w-4" />}
      {eaten ? t("j_logged") : t("j_eat_recipe")}
    </button>
  );
}
